import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import { Dropdown, DropdownProps, MenuProps } from "antd";

import styles from "./index.module.scss";

import { AccountEnum } from "store/balances";

const { useTranslation } = Hooks;

interface Props extends DropdownProps {
  value: AccountEnum;
  skip?: AccountEnum[];
  onChange?: (val: AccountEnum) => void;
}

const Main: React.FC<Props> = ({ value, skip, onChange, ...rest }) => {
  const t = useTranslation();

  const accList = useMemo(
    () => [
      { key: AccountEnum.spot, label: t("trade.accSpot") },
      { key: AccountEnum.lever, label: t("trade.accMargin") },
    ],
    [t]
  );

  const atvAccDoc = useMemo(() => accList.find((doc) => doc.key === value) || { label: "" }, [accList, value]);

  const items: MenuProps["items"] = useMemo(() => {
    const retAry: MenuProps["items"] = [];
    accList.map(({ key, label }) => {
      if (skip && skip.includes(key)) return false;
      retAry.push({
        key,
        label: (
          <a onClick={() => onChange && onChange(key)}>
            <span>{label}</span>
          </a>
        ),
      });
    });
    return retAry;
  }, [accList, onChange, skip]);

  return (
    <Dropdown
      overlayClassName={styles.main}
      menu={{
        items,
        selectable: true,
        selectedKeys: [value],
      }}
      {...rest}
    >
      <button className={cx("btnTxt btnDrop", styles.trigger)} onClick={(e) => e.preventDefault()}>
        {atvAccDoc.label}
      </button>
    </Dropdown>
  );
};

export default observer(Main);
